import * as R from 'ramda';
import { Component, Input } from '@angular/core';
import { GridService } from '@app/edit/grid.service';
import { each } from 'lodash';
import Section from '@app/section';
import settings from '@app/app.settings';

@Component({
  selector: 'app-content-panel-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less']
})
export class LayoutComponent {
  @Input() activeSection: Section;
  constructor(public gridService: GridService) { }

  setWall() {
    let
      x = 0,
      y = 0;

    each(this.gridService.centralCards, (card, index) => {
      this.gridService.centralCards[index] = {
        ...card,
        cols: 1,
        rows: 1,
        x,
        y,
      };

      if (x < this.gridService.options.maxCols - 1) {
        x++;
      } else if (x === this.gridService.options.maxCols - 1) {
        x = 0;
        y++;
      }
    });
  }

  setDeck() {
    const

      // Clean up the grid and fully recreate it — more efficient then updating layout of non-empty grid
      centralCardsCopy = R.clone(this.gridService.centralCards);

    let
      coords = {x: 0, y: 0};

    this.gridService.centralCards.splice(0, this.gridService.centralCards.length);

    each(centralCardsCopy, card => {
      this.gridService.centralCards.push({
        ...card,
        cols: 1,
        rows: (card.text || '').length > settings.maxTextSizeForOneRow ? 2 : 1,
        x: coords.x,
        y: coords.y,
      });

       coords = this.findNextEmptyCoords(coords);
    });
  }

  setLetter() {
    const
      centralCardsCopy = R.clone(this.gridService.centralCards);

    let
      coords = { x: 0, y: 0 };

    this.gridService.centralCards.splice(0, this.gridService.centralCards.length);

    each(centralCardsCopy, (card, index) => {
      this.gridService.centralCards.push({
        ...card,
        cols          : index === 0 ? 2 : 1,
        rows          : index === 0 ? 2 : 1,
        x             : coords.x,
        y             : coords.y,
      });

      coords = this.findNextEmptyCoords(coords);
    });
  }

  findNextEmptyCoords(coords) {
    if (coords.x < this.gridService.options.maxCols - 1) {
      if (this.gridService.isCellEmpty(coords.x + 1, coords.y)) {
        return { x: coords.x + 1, y: coords.y };
      }

      return this.findNextEmptyCoords({ x: coords.x + 1, y: coords.y });
    }

    if (this.gridService.isCellEmpty(0, coords.y + 1)) {
      return { x: 0, y: coords.y + 1 };
    }

    return this.findNextEmptyCoords({ x: 0, y: coords.y + 1 });
  }

  setSetting(params) {
    this.activeSection.layout[params.name] = params.value;

    if (params.name !== 'type') {
      return;
    }

    if (params.value === 'wall') {
      this.setWall();
    }

    if (params.value === 'deck') {
      this.setDeck();
    }

    if (params.value === 'letter') {
      this.setLetter();
    }
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/layout/layout.component.ts